import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { PresetSet } from '@jax-data-science/sci-image-visualizer';
import { environment } from '../../environments/environment';

/**
 * Per-user annotation-class presets (jit-ui#70).
 *
 * Mirrors {@link ProcessService}'s HTTP pattern against `slideCropServer` (the
 * `/api/` backend). The user is keyed server-side from the Auth0 JWT, so no user
 * id is sent; the auth interceptor attaches the Bearer token automatically.
 */
@Injectable({ providedIn: 'root' })
export class PreferencesService {
  private url: string;

  constructor(private http: HttpClient) {
    this.url = environment.slideCropServer;
  }

  private join(path: string): string {
    const base = this.url.endsWith('/') ? this.url : `${this.url}/`;
    const p = path.startsWith('/') ? path.substring(1) : path;
    return `${base}${p}`;
  }

  /** GET the caller's saved preset set (server returns an empty set if none saved). */
  getAnnotationClasses(): Observable<PresetSet> {
    return this.http.get<PresetSet>(this.join('preferences/annotation-classes'));
  }

  /** PUT (upsert) the caller's preset set. */
  saveAnnotationClasses(set: PresetSet): Observable<PresetSet> {
    return this.http.put<PresetSet>(this.join('preferences/annotation-classes'), set);
  }
}
